module.exports = __webpack_public_path__ + "media/images/light-button-fb8dfc40a334ab8002c5e5d19c26b110.png";